const Mn = require('backbone.marionette');
const Template = require('balus/ui/template/body/group/content/index.hbs');
const DescTemplate = require('balus/ui/template/body/group/content/description.hbs');
const Marked = require('balus/util/marked');

const GroupDescriptionView = Mn.View.extend({
    template: DescTemplate,

    serializeData: function() {
        let j = this.model.toJSON();
        j.description = Marked()(j.description ? j.description : '');
        return j;
    },

    onRender: function() {
        this.$el.externalLinkTargetBlank();
    }
});

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        groupDescription: '.group-description-wrapper'
    },

    onRender: function() {
        this.showChildView('groupDescription', new GroupDescriptionView({
            model: this.model
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/content/index.js